var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "4 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.026 6.814 6.814 8.026l4.243 4.243-4.243 4.242 1.212 1.213 4.243-4.243 4.242 4.243 1.213-1.213-4.243-4.242 4.243-4.243-1.212-1.212-4.243 4.243-4.243-4.243Z",
    fill: "#4B4F54"
  })));
};
export default SvgClose;